
/* injects from baggage-loader */

'use strict';

import InvestFormController from './invest.form.controller';
import InvestFormTemplate from './invest.form.html';

export default class InvestFormComponent {
		constructor() {
				this.templateUrl = InvestFormTemplate;
				this.controller = InvestFormController;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				this.bindings = { 
					project: '<',
					documents: '<',
					investment: '<',
					investorProfiles: '<',
					countryList: '<',
					sidePanelData: '<',
					updateSummaryData: '&',
					investmentFees: '<'
				};
		}
}
